import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { dataProvider, PaymentPageDataContextProvider, usePaymentPageData, PaymentPageThemeContextProvider } from '@switch/cardpayments';
import { LoadingContextProvider, SwitchThemeContextProvider, TranslationLoaderContextProvider, useLoading, useSwitchTheme, useTranslationLoader } from '@switch/core';
import { enGB } from 'date-fns/locale';
import React, { lazy, Suspense } from 'react';
import {
    AdminContext,
    AdminUI,
    CustomRoutes,
    Loading,
} from "react-admin";
import { Route, useLocation, useSearchParams } from "react-router-dom";
import english from "./locales/en/translation.json";


const PaymentPage = lazy(() => import("@switch/cardpayments").then(module => ({ default: module.PaymentPage })));
const Layout = lazy(() => import("@switch/cardpayments").then(module => ({ default: module.PaymentPageLayout })));

export const PaymentPageLoader = () => {
    let [params, setParams] = useSearchParams();
    let monitor = params.get("monitor");
    let sessionKey = params.get("sessionKey");

    const location = useLocation()
    const parts = location.pathname.split("/");
    const bookingId = parts.at(-2);
    const paymentId = parts.at(-1);

    return (
        <Suspense fallback={<Loading />}>
            <LoadingContextProvider>
                <TranslationLoaderContextProvider defaults={{ english }} storekey='paymentpage.settings.translation' >
                    <PaymentPageDataContextProvider bookingId={bookingId} paymentId={paymentId} monitor={monitor} sessionKey={sessionKey}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                            <SwitchThemeContextProvider>
                                <PaymentPageThemeContextProvider>
                                    <ThemeWrapper />
                                </PaymentPageThemeContextProvider>
                            </SwitchThemeContextProvider>
                        </LocalizationProvider>
                    </PaymentPageDataContextProvider>
                </TranslationLoaderContextProvider>
            </LoadingContextProvider>
        </Suspense>
    );
}

const ThemeWrapper = () => {
    const { widgetKey } = usePaymentPageData()
    const { i18nProvider } = useTranslationLoader()
    const { isLoading } = useLoading()
    const { theme } = useSwitchTheme()
    const dateProviderInstance = dataProvider(widgetKey)

    if (isLoading) return (<div class="loader-container">   <div class="loader">Loading...</div>    </div>)

    return (
        <AdminContext
            basename="/Payment"
            dataProvider={dateProviderInstance}
            theme={theme?.light}
            darkTheme={theme?.dark}
            i18nProvider={i18nProvider}
        >
            <AdminUI
                layout={Layout}
            >
                <CustomRoutes>
                    <Route path="/:bookingId/:paymentId" element={<PaymentPage />} />
                </CustomRoutes>
            </AdminUI>
        </AdminContext>
    )
}

